module.exports = __webpack_public_path__ + "img/xmsb10.894c43b3.png";